import { InvoicesDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  DeleteFinanceInvoiceDocument,
  DeleteFinanceInvoiceMutationVariables,
  InvoicesDetailPageInvoiceDocument,
  UpdateFinanceInvoiceDocument,
  UpdateFinanceInvoiceMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDelete = () => {
  const [deleteInvoice, { loading }] = useMutation(DeleteFinanceInvoiceDocument, {
    extractorFn: (data) => data.financeMutations.deleteFinanceFinancialDocument,
    refetchQueries: [InvoicesDataTableDocument],
  })

  return {
    delete: (variables: DeleteFinanceInvoiceMutationVariables) => deleteInvoice({ variables }),
    loading,
  }
}

export const useUpdate = (invoiceId: number, companyId: number) => {
  const [updateInvoice, { loading }] = useMutation(UpdateFinanceInvoiceDocument, {
    extractorFn: (data) => data.financeMutations.updateFinanceFinancialDocument,
    refetchQueries: [
      {
        query: InvoicesDetailPageInvoiceDocument,
        variables: {
          id: invoiceId,
          companyId: companyId,
        },
      },
    ],
  })

  return {
    update: (variables: UpdateFinanceInvoiceMutationVariables) => updateInvoice({ variables }),
    loading,
  }
}
